import type { OptionItem } from "~/types";
// 問い合わせ 進捗
export const FormProgressStepList = [
  { key: "1", name: "内容入力" },
  { key: "2", name: "確認" },
  { key: "3", name: "送信" },
];

// 問い合わせ ご希望内容
/**
 * 旧フォームの対応
 * 1: 資料請求 -> 削除
 * 2: 見積依頼
 * 3: ご相談・お問い合わせ
 * 4: 採用問合せ
 */
export const purposeList: OptionItem[] = [
  { id: 2, name: "見積依頼" },
  { id: 3, name: "ご相談・お問い合わせ" },
  { id: 5, name: "資料請求 + お見積り" },
  { id: 4, name: "採用問合せ" },
];

// 問い合わせ ご予定工種
export const workList: OptionItem[] = [
  { id: 1, name: "新築外構(全体)" },
  { id: 2, name: "新築外構(部分のみ)" },
  { id: 3, name: "全体リフォーム" },
  { id: 4, name: "車庫まわりリフォーム" },
  { id: 5, name: "玄関まわりリフォーム" },
  { id: 6, name: "お庭まわりリフォーム" },
  { id: 7, name: "複数リフォーム" },
  { id: 8, name: "水まわり" },
];

// 問い合わせ アンケート1問目 やりたいこと
export const wishList: OptionItem[] = [
  { id: 1, name: "バーベキューがしたい" },
  { id: 2, name: "プールで遊ばせたい" },
  { id: 3, name: "ペットを遊ばせたい" },
  { id: 4, name: "天候から車を守りたい" },
  { id: 5, name: "玄関までぬれずに歩きたい" },
  { id: 6, name: "隣家の目線を防ぎたい" },
  { id: 7, name: "道路からの目線を防ぎたい" },
  { id: 8, name: "防犯対策をしっかりしたい" },
  { id: 9, name: "古いものを新しくしたい" },
  { id: 10, name: "眺めのいい庭でくつろぎたい" },
  { id: 11, name: "家庭菜園を楽しみたい" },
  { id: 12, name: "収納を増やしたい" },
  { id: 13, name: "とにかく見た目をよくしたい" },
  { id: 14, name: "見た目より金額優先" },
];

// 問い合わせ アンケート2問目 流入経路
export const inflowSources = [
  {
    name: "検索やSNSなど",
    list: [
      { id: 1, name: "Google" },
      { id: 2, name: "Bing" },
      { id: 3, name: "Yahoo!" },
      { id: 4, name: "Instagram" },
      { id: 5, name: "Pinterest" },
      { id: 6, name: "X(Twitter)" },
    ],
  },
  {
    name: "記事や紹介など",
    list: [
      { id: 7, name: "ファミリー庭園工事コミコミショップ" },
      { id: 8, name: "他のホームページのリンクから" },
      { id: 9, name: "ダイレクトメール・チラシなど" },
      { id: 10, name: "友人・知人の紹介" },
      { id: 11, name: "雑誌・新聞などの紹介" },
      { id: 12, name: "ブログや口コミなどの情報" },
    ],
  },
];

// 希望の連絡方法
export const howToContact: OptionItem[] = [
  { id: 1, name: "どちらでも可" },
  { id: 2, name: "メール" },
  { id: 3, name: "電話" },
];
